import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=0c3b5f4e&scoped=true&"
import script from "./Me.vue?vue&type=script&lang=js&"
export * from "./Me.vue?vue&type=script&lang=js&"
import style0 from "./Me.vue?vue&type=style&index=0&id=0c3b5f4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b5f4e",
  null
  
)

export default component.exports